import { ApolloError, useQuery } from '@apollo/client';
import { PriceVisibility, PricingModel } from 'src/App/generated/graphql-types';
import { getHirerAccountQuery } from 'src/queries/hirerAccountQuery';

const useHirerAccountData = (
  advertiserId?: string,
): {
  isLoading: boolean;
  data?: {
    hirerAccount?: {
      priceVisibility: PriceVisibility;
      pricingModel: PricingModel;
    };
  };
  error?: ApolloError;
} => {
  const { data, error, loading, previousData } = useQuery(
    getHirerAccountQuery,
    {
      variables: {
        advertiserId: advertiserId ? parseInt(advertiserId, 10) : undefined,
      },
      skip: !advertiserId,
    },
  );

  return {
    isLoading: loading,
    data: loading && previousData ? previousData : data,
    error,
  };
};

export const useHirerPriceVisibility = (
  advertiserId?: string,
): {
  isLoading: boolean;
  data?: PriceVisibility;
  error?: ApolloError;
} => {
  const { isLoading, data, error } = useHirerAccountData(advertiserId);

  const priceVisibility =
    data?.hirerAccount?.priceVisibility ??
    PriceVisibility.SHOW_DISCOUNTED_PRICE;

  return { isLoading, data: priceVisibility, error };
};

export const useHirerPricingModel = (
  advertiserId?: string,
): {
  isLoading: boolean;
  data?: PricingModel;
  error?: ApolloError;
} => {
  const { isLoading, data, error } = useHirerAccountData(advertiserId);

  return {
    isLoading,
    error,
    data: data?.hirerAccount?.pricingModel,
  };
};
